
import { defineComponent, PropType } from 'vue';
interface Option {
  name: string;
  id: string | number;
  [x: string | number | symbol]: unknown;
}
export default defineComponent({
  name: 'Dropdown',
  template: 'Dropdown',
  props: {
    name: {
      type: String,
      required: false,
      default: 'dropdown',
      note: 'Input name'
    },
    options: {
      type: Array as PropType<Array<Option>>,
      required: true,
      default: [],
      note: 'Options of dropdown. An array of options with id and name'
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Please select an option',
      note: 'Placeholder of dropdown'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
      note: 'Disable the dropdown'
    },
    maxItem: {
      type: Number,
      required: false,
      default: 6,
      note: 'Max items showing'
    },
    initiallySelected: {
      type: Option,
      required: false,
      default: null,
      note: 'initially chosen item'
    }
  },
  data(): {
    selected: Option | null;
    optionsShown: boolean;
    searchFilter: string;
  } {
    return {
      selected: null,
      optionsShown: false,
      searchFilter: ''
    };
  },
  created() {
    if (this.$props.initiallySelected != null) {
      this.selectOption(
        this.options.find(
          (option: Option) => option.id === this.$props.initiallySelected.id
        )!
      );
    }
  },

  computed: {
    filteredOptions(): Array<Option> {
      const filtered = [];
      const regOption = new RegExp(this.searchFilter, 'ig');
      for (const option of this.options) {
        if (
          this.searchFilter != undefined &&
          (this.searchFilter.length < 1 || option.name.match(regOption))
        ) {
          if (filtered.length < this.maxItem) filtered.push(option);
        }
      }
      return filtered;
    }
  },
  methods: {
    selectOption(option: Option) {
      this.selected = option;
      this.optionsShown = false;
      this.searchFilter = this.selected.name;
      this.$emit('selected', this.selected);
    },
    showOptions() {
      if (!this.disabled) {
        this.searchFilter = '';
        this.optionsShown = true;
      }
    },
    exit() {
      if (this.selected !== null) {
        this.searchFilter = this.selected.name;
        this.$emit('selected', this.selected);
      }
      this.optionsShown = false;
    },
    // Selecting when pressing Enter
    keyMonitor: function (event: any) {
      if (event.key === 'Enter' && this.filteredOptions[0])
        this.selectOption(this.filteredOptions[0]);
    }
  },
  watch: {
    searchFilter() {
      this.$emit('filter', this.searchFilter);
    }
  }
});
